/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import ActionModel from 'cio/models/action';
import CampaignModel from 'cio/models/campaign';
import { Editor } from 'cio/services/editor';
import TemplateModel from 'cio/models/template';

interface CreateEventBodyEditorJsonArgs {
  action: ActionModel;
  campaign: CampaignModel;
  template: TemplateModel;
  body: string;
  onBodyChange: (body: string) => unknown;
  switchEditor: (editor: Editor) => unknown;
  hasReadOnlyPermission: boolean;
}

const ACE_EDITOR_MODES: Partial<Record<Editor, string>> = {
  [Editor.JS]: 'javascript',
  [Editor.JSON]: 'json',
};

export default class CreateEventBodyEditorJson extends Component<CreateEventBodyEditorJsonArgs> {
  Editor = Editor;

  get aceMode() {
    return ACE_EDITOR_MODES[this.args.template.editor];
  }

  radioInputs: {
    [key in Editor.JS | Editor.JSON]: HTMLInputElement | null;
  } = {
    [Editor.JS]: null,
    [Editor.JSON]: null,
  };

  @action
  didInsertRadio(type: Editor.JS | Editor.JSON, element: HTMLElement) {
    let radio = element.querySelector('input');

    if (radio == null) {
      return;
    }

    this.radioInputs = { ...this.radioInputs, [type]: radio };
  }

  @action
  onContentChange(content: string) {
    this.args.onBodyChange(content);
  }

  @action
  switchEditor(targetEditor: Editor.JS | Editor.JSON) {
    if (this.args.template.editor === targetEditor) {
      return;
    }

    // We need to manually uncheck the clicked radio input, because we show a
    // confirmation modal before actually switching.
    // Clicking a radio input marks it as checked, which is regular browser
    // behavior.
    // If we cancel out of the confirmation modal, two radio inputs would be
    // visible as checked.
    // If the confirmation modal gets confirmed, the radio inputs rerender and
    // the correct one gets checked accordingly again.
    let radioInput = this.radioInputs[targetEditor];
    if (radioInput != null) {
      radioInput.checked = false;
    }

    this.args.switchEditor(targetEditor);
  }
}
